import React from "react";
import { Link } from "react-scroll";
import resume from "../docs/Prathmesh_Kurane_Resume.pdf";

export default function Navbar(Props) {
  const resumeDownload = () => {
    window.open(
      "https://drive.google.com/file/d/1Qw09sia4nURU-e98OHywHfOCQs1kzHZv/view?usp=sharing",
      "_blank"
    );
  };
  return (
    <nav
      className="navbar sticky-top bg-opacity-20 navbar-expand-lg bg-dark p-3 mb-5 bg-body nav-bsh"
      id="nav-menu"
    >
      <div className="container-fluid ">
        <a
          class="nav-link home"
          className="navbar-brand"
          href="#"
          aria-current="page"
          smooth={true}
          duration={100}
        >
          <img
            src="https://img.icons8.com/fluency/256/sound-recording-copyright.png"
            alt="Bootstrap"
            width={30}
            height={30}
          />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse " id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0 mx-auto ">
            <li className="nav-item  pe-3 ps-3">
              <Link
                className="nav-link home IBM-Plex-Mono navmenu"
                aria-current="page"
                to="home"
                href="#"
                smooth={true}
                duration={100}
                activeClass="active"
                spy={true}
              >
                HOME
              </Link>
            </li>
            <li className="nav-item  pe-3 ps-3">
              <Link
                className="nav-link about IBM-Plex-Mono navmenu"
                aria-current="page"
                to="about"
                smooth={true}
                duration={100}
              >
                ABOUT
              </Link>
            </li>

            <li className="nav-item pe-3 ps-3">
              <Link
                className="nav-link skills IBM-Plex-Mono navmenu"
                aria-current="page"
                to="skills"
                smooth={true}
                duration={100}
              >
                SKILLS
              </Link>
            </li>
            <li className="nav-item pe-3 ps-3">
              <Link
                className="nav-link projects IBM-Plex-Mono navmenu"
                aria-current="page"
                to="projects"
                smooth={true}
                duration={100}
              >
                PROJECTS
              </Link>
            </li>
            <li className="nav-item pe-3 ps-3">
              <Link
                className="nav-link contact IBM-Plex-Mono navmenu"
                aria-current="page"
                to="contact"
                smooth={true}
                duration={100}
              >
                CONTACT
              </Link>
            </li>
            <li className="nav-item pe-3 ps-3">
              <button className="border-0" id="resume-button-1" onClick={resumeDownload}>
                <a
                  id="resume-link-1"
                  className="IBM-Plex-Mono nav-link resume btn btn-primary btn-hover"
                  aria-current="page"
                  role="button"
                  href={resume}
                  download={resume}
                >
                  RESUME
                </a>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
